
export const ALLOWED_QUERY_PARAMS = [
  'service_intent',
  'device',
  'source_type',
  'source_url',
  'campaign_name',
  'campaign_medium',
  'campaign_source',
  'campaign_term',
  'sub_source',
  'source_details',
  'device_type',
  'utm_campaign',
  'utm_medium',
  'utm_source',
  'utm_term',
  'utm_adgroup',
  'utm_content',
  'channel',
  'ad_extension_id',
  'match_type',
  'keyword_type',
  'location',
  'network_type',
  'creative_id',
  'display_placement',
  'display_category',
  'ad_position',
  'cs_plan_name',
  'merchant_account_id',
];

export const AUTH_QUERY_PARAMS = {
  authToken: 'authToken',
  merchantUuid: 'merchantUuid',
};
